module.exports = __webpack_public_path__ + "img/556c2d75e0484b9fa35a0d5e7e9f1120_mergeImage.82f886a1.png";